import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl, headersDefault } from ".";
import { postNotificationsSubscription } from "./userActions";
/** GET /api/push-notifications/mute-status -> { is_muted: boolean, has_token?: boolean } */
export const getMuteStatus = createAsyncThunk(
  "pushMute/getMuteStatus",
  async () => {
    const res = await fetch(`${baseUrl}/api/push-notifications/mute-status`, {
      method: "GET",
      headers: headersDefault(),
    });
    if (res.status !== 200) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error ?? "GenericError");
    }
    const data = await res.json();
    console.log("data", data);
    // Normalize optional has_token to boolean (false if missing)
    return { is_muted: !!data.is_muted };
  }
);

/** PATCH /api/push-notifications/toggle-mute { is_muted } -> { success, message, is_muted } */
export const toggleMute = createAsyncThunk(
  "pushMute/toggleMute",
  async ({ is_muted }) => {
    const res = await fetch(`${baseUrl}/api/push-notifications/toggle-mute`, {
      method: "PATCH",
      headers: headersDefault(),
      body: JSON.stringify({ is_muted }),
    });
    if (res.status !== 200) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error ?? "GenericError");
    }
    return await res.json(); // { success, message, is_muted }
  }
);
